export const SMTPCONFIG_URL = '/email-config';